import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListStateCell } from './transaction-list-state.cell';
import { TransactionListStateHeader } from './transaction-list-state.header';

export const TransactionListStateColumn: IdentifiedColumnDef<
  TransactionModel,
  TransactionModel['state']
> = {
  enableSorting: false,
  header: TransactionListStateHeader,
  cell: TransactionListStateCell,
  meta: { maxWidth: '150px', width: '130px', minWidth: '80px' },
};
